/**
 * Utility functions for league-related operations
 */

/**
 * Expands common league abbreviations to their full names
 */
export const expandLeagueAbbreviation = (leagueName: string): string => {
  const abbreviations: Record<string, string> = {
    'NAL': 'National Academy League',
    'DPL': 'Development Player League',
    'ECNL': 'Elite Clubs National League',
    'GA': 'Girls Academy',
    'MLS NEXT': 'MLS NEXT',
    'NPL': 'National Premier League',
    'UPSL': 'United Premier Soccer League',
    'NISA': 'National Independent Soccer Association',
    'USL': 'United Soccer League',
    'USSF': 'United States Soccer Federation',
    'AYSO': 'American Youth Soccer Organization',
    'SAY': 'Soccer Association for Youth',
    'USYS': 'US Youth Soccer',
    'USCS': 'United States Club Soccer',
    'EDP': 'Eastern Development Program',
    'CASL': 'Capital Area Soccer League',
    'NCFC': 'North Carolina Football Club',
    'THUSC': 'Triangle United Soccer Club',
    'NCYSA': 'North Carolina Youth Soccer Association',
    'SAPL': 'South Atlantic Premiere League',
    'Aspire': 'Girls Academy - Aspire'
  };

  // Check for exact matches first
  if (abbreviations[leagueName]) {
    return abbreviations[leagueName];
  }

  // Check for partial matches (e.g., "DPL - U15 Girls SE" should match "DPL")
  for (const [abbrev, fullName] of Object.entries(abbreviations)) {
    if (leagueName.startsWith(abbrev + ' ') || leagueName.startsWith(abbrev + '-')) {
      return fullName;
    }
  }

  // If no match found, return the original name
  return leagueName;
};
